import * as APIModels from "../../../../models";
import { DataService } from "../../../../services/DataService";

const doAllDocumentsHaveSecurity = (
    completedDocuments: Array<APIModels.Document>
): boolean => {
    let result;
    if (completedDocuments.length === 1) {
        result =
            completedDocuments[0].securityID !== null &&
            completedDocuments[0].securityID !== undefined &&
            completedDocuments[0].securityID !== "" &&
            completedDocuments[0].securityID !== APIModels.EmptyGuid;
    } else {
        result =
            completedDocuments
                .map((doc) => {
                    return doc.securityID;
                })
                .map(
                    (doc) =>
                        doc !== null &&
                        doc !== undefined &&
                        doc !== "" &&
                        doc !== APIModels.EmptyGuid
                )
                .reduce((a, b) => a && b) ?? false;
    }
    console.warn("doAllDocumentsHaveSecurity", result);
    return result;
};
export const doAllDocumentsHaveFilingCode = (
    completedDocuments: Array<APIModels.Document>
): boolean => {
    let result;
    if (completedDocuments.length === 1) {
        result =
            completedDocuments[0].filingCodeID !== null &&
            completedDocuments[0].filingCodeID !== undefined &&
            completedDocuments[0].filingCodeID !== "" &&
            completedDocuments[0].filingCodeID !== APIModels.EmptyGuid;
    } else {
        result =
            completedDocuments
                .map((doc) => {
                    return doc.filingCodeID;
                })
                .map(
                    (doc) =>
                        doc !== null &&
                        doc !== undefined &&
                        doc !== "" &&
                        doc !== APIModels.EmptyGuid
                )
                .reduce((a, b) => a && b) ?? false;
    }
    console.warn("doAllDocumentsHaveFilingCode", result);
    return result;
};
const doAllDocumentsHaveFilingCodeComponents = (
    completedDocuments: Array<APIModels.Document>
): boolean => {
    let result;
    if (completedDocuments.length === 1) {
        result =
            completedDocuments[0].filingComponentID !== null &&
            completedDocuments[0].filingComponentID !== undefined &&
            completedDocuments[0].filingComponentID !== "" &&
            completedDocuments[0].filingComponentID !== APIModels.EmptyGuid;
    } else {
        result =
            completedDocuments
                .map((doc) => {
                    return doc.filingComponentID;
                })
                .map(
                    (doc) =>
                        doc !== null &&
                        doc !== undefined &&
                        doc !== "" &&
                        doc !== APIModels.EmptyGuid
                )
                .reduce((a, b) => a && b) ?? false;
    }
    console.warn("doAllDocumentsHaveFilingCodeComponents", result);
    return result;
};
const isTyler = (completedSubmission: APIModels.Submission): boolean => {
    const isGA =
        completedSubmission.portalIdentifier === "GA" && // if this is true then it is peach court and not Georgia Tyler Tech
        completedSubmission.caseData &&
        completedSubmission.caseData.caseTypeID != APIModels.EmptyGuid;
    return !isGA || false; // if it;
};

export const hasNoSecurityTypesForFilingCode = (
    submission: APIModels.Submission
): boolean => {
    if (!isTyler(submission)) {
        return true;
    }

    const docs = submission.documents || [];
    if (docs.length === 0) {
        return true;
    }

    return docs.every(
        (doc) =>
            doc.filingCodeID &&
            doc.filingCodeID !== "" &&
            doc.filingCodeID !== APIModels.EmptyGuid &&
            (!doc.securityID ||
                doc.securityID === "" ||
                doc.securityID === APIModels.EmptyGuid)
    );
};

const canSubmit = (
    completedSubmission: APIModels.Submission,
    availableSecurityTypes?: any
): boolean => {
    let isGeorgiaPeachCourt = false;
    console.log("county", completedSubmission.caseData?.countyID);
    DataService.getCounty({
        countyId: completedSubmission.caseData?.countyID ?? APIModels.EmptyGuid,
    }).then((resp) => {
        if (resp.portalIdentifier === "GA") {
            isGeorgiaPeachCourt = true;
        }
    });

    if (isGeorgiaPeachCourt) {
        return true;
    }

    console.log("canSubmit", {
        Tyler: {
            "Is this a TYLER State": isTyler(completedSubmission),
            "Portal Code": completedSubmission.portalIdentifier,
        },
        "Available Security Types From API": {
            what: availableSecurityTypes,
            has: !(
                availableSecurityTypes || availableSecurityTypes.length === 0
            ),
        },
        components: {
            "Has all Security Types": doAllDocumentsHaveSecurity(
                completedSubmission.documents!
            ),
            "Has all Filing Code": doAllDocumentsHaveFilingCode(
                completedSubmission.documents!
            ),
            "Has all Filing Code Components":
                doAllDocumentsHaveFilingCodeComponents(
                    completedSubmission.documents!
                ),
        },
    });
    if (!isTyler(completedSubmission)) {
        return true;
    }

    if (!availableSecurityTypes || availableSecurityTypes.length === 0) {
        return true;
    }

    return (
        doAllDocumentsHaveSecurity(completedSubmission.documents!) &&
        doAllDocumentsHaveFilingCode(completedSubmission.documents!) &&
        doAllDocumentsHaveFilingCodeComponents(completedSubmission.documents!)
    );
};

export default canSubmit;
